import { render } from "./InspectionLocationComponent.vue?vue&type=template&id=06d11fbc"
import script from "./InspectionLocationComponent.vue?vue&type=script&lang=js"
export * from "./InspectionLocationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__